export function CalendarViewDay(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon / Calendar View / Day">
          <g id="Icon">
            <path
              d="M35.6 32H12.4C11.0745 32 10 33.0745 10 34.4C10 35.7255 11.0745 36.8 12.4 36.8H35.6C36.9255 36.8 38 35.7255 38 34.4C38 33.0745 36.9255 32 35.6 32Z"
              fill="currentColor"
            />
            <path
              d="M12.4 21.6H35.6C36.9255 21.6 38 22.6745 38 24C38 25.3255 36.9255 26.4 35.6 26.4H12.4C11.0745 26.4 10 25.3255 10 24C10 22.6745 11.0745 21.6 12.4 21.6Z"
              fill="currentColor"
            />
            <path
              d="M35.6 11.2H12.4C11.0745 11.2 10 12.2745 10 13.6C10 14.9255 11.0745 16 12.4 16H35.6C36.9255 16 38 14.9255 38 13.6C38 12.2745 36.9255 11.2 35.6 11.2Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M37.6 0H10.4C4.65624 0 0 4.65624 0 10.4V37.6C0 43.3438 4.65624 48 10.4 48H37.6C43.3438 48 48 43.3438 48 37.6V10.4C48 4.65624 43.3438 0 37.6 0ZM10.4 4.8H37.6C40.6928 4.8 43.2 7.30721 43.2 10.4V37.6C43.2 40.6928 40.6928 43.2 37.6 43.2H10.4C7.30721 43.2 4.8 40.6928 4.8 37.6V10.4C4.8 7.30721 7.30721 4.8 10.4 4.8Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}
